import { parsePhoneNumber } from "awesome-phonenumber";

import { useTranslation } from "react-i18next";

import Flex from "../../../components/Flex/Flex";
import ImageAvatar from "../../ui/components/ImageAvatar/ImageAvatar";

import useOrganizationRoleTranslations from "../../organizations/hooks/useOrganizationRoleTranslations";

import useUserRoles from "./useUserRoles";

export default function useUsersTableColumns({ organization, indexName } = {}) {
	const { t } = useTranslation();

	const organizationRoleTranslations = useOrganizationRoleTranslations();
	const roles = useUserRoles();

	return [
		{
			id: "name",
			Header: t("name"),
			accessor: ({ name }) => name,
			Cell: ({ value, row }) => (
				<Flex gap={10} justifyContent="flex-start">
					<ImageAvatar src={row.avatarImg} />
					<span>{value}</span>
				</Flex>
			),
		},
		{
			id: "email",
			Header: t("email"),
		},
		{
			id: "phone",
			Header: t("telephone"),
			collapsing: true,
			accessor: ({ phone }) => phone && parsePhoneNumber(phone).getNumber("international"),
		},
		indexName === "users" && {
			id: "roles",
			Header: t("role", "Role"),
			accessor: ({ permissions }) => {
				const organizationPermissions = permissions?.[organization?.type]?.[organization.id];

				if (organizationPermissions) {
					return (
						(organizationPermissions || [])
							.filter((role) => role !== "any")
							.map((role) => organizationRoleTranslations[role])
							.filter(Boolean)
							.join(", ") || t("none", "None")
					);
				}

				return roles[permissions?.role];
			},
		},
	];
}
